export default __webpack_public_path__ + "static/media/BC_488_BC_R0118_tn.70c27def.jpg";